import grapesjs from "grapesjs";
import "grapesjs/dist/css/grapes.min.css";
import "grapesjs-preset-webpage/dist/";
import { useEffect, useLayoutEffect, useState } from "react";
import preset from "grapesjs-preset-webpage";
import basics from "grapesjs-blocks-basic";
import countdown from "grapesjs-component-countdown";
import pluginExport from "grapesjs-plugin-export";
import touch from "grapesjs-touch";
import parser from "grapesjs-parser-postcss";
import imageEditor from "grapesjs-tui-image-editor";
import typed from "grapesjs-typed";
import styleBg from "grapesjs-style-bg";
import fr from "grapesjs/locale/fr.js";
import { Stack } from "@mui/material";
import { htmlFile } from "./htmlFile.jsx";
import { modals } from "@mantine/modals";
import GrapeModal from "./GrapeModal.jsx";
import { getFields } from "../../api/ContactAPI.js";
import { Button, LoadingOverlay, Tooltip } from "@mantine/core";
import { IconArrowLeft, IconDeviceFloppy } from "@tabler/icons-react";
import { createForm, editForm } from "../../api/FormsAPI.js";
import { useNavigate } from "react-router-dom";
import { useFormStore } from "../../stores/FormStore.js";
import { useLanguage } from "../../stores/LanguageStore.js";
import { useProfileStore } from "../../stores/UserStore.js";

const script = function () {
  const lang = useLanguage.getState().language;
  modals.open({
    modalId: "grape-modal",
    title: lang.forms.config_title,
    size: "xl",
    children: <GrapeModal current={this} editor={this.em} />,
  });
};

function handleDomSelect({ item }) {
  return `
    <div class="form-element">
      <label for="field-${item.id}">
        ${item.label} ${item?.required ? "<span class='required-indicator'>*</span>" : ""
    }
      </label>
      <select class="form-input" name="${item.identifier_placeholder
    }" id="field-${item.id}" required=${item?.required ? "true" : "false"
    } placeholder="${item?.placeholder || ""}" type="select">
        ${item?.options
      ?.map((option) => `<option value="${option}">${option}</option>`)
      .join(" ")}
      </select>
    </div>
    `;
}

function handleDomInput({ item }) {
  return `
    <div class="form-element">
      <label for="field-${item.id}">
        ${item.label} ${item?.required ? "<span class='required-indicator'>*</span>" : ""
    }
      </label>
      <input class="form-input" name="${item.identifier_placeholder
    }" id="field-${item.id}" type="${item.type || "text"}"
     ${item?.required ? "required" : ""} placeholder="${item?.placeholder || ""
    }" />
    </div>
    `;
}

function handleDomCheckbox({ item }) {
  return `
    <div class="form-element checkbox">
      <input class="form-check" name="${item.identifier_placeholder}" id="field-${item.id}" type="checkbox" />
      <label for="field-${item.id}">
        ${item.label}
      </label>
    </div>
    `;
}

function parseCustomForm(html) {
  // Create a temporary DOM element to parse the HTML
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html.trim();

  // Find the form element
  const formElement = tempDiv.querySelector(".custom-form");
  if (!formElement) {
    console.error("No form element found");
    return null;
  }

  // Extract attributes from the form
  const attributes = {
    method: formElement.getAttribute("method") || "",
    action: formElement.getAttribute("action") || "",
    class: formElement.getAttribute("class") || "",
    id: formElement.getAttribute("id") || "",
  };

  // Extract data fields
  const datafields = Array.from(
    formElement.querySelectorAll("input, textarea, select")
  ).map((field, index) => {
    let elementId = parseInt(field.getAttribute("id")?.substring(6)) || "";
    let elementLabel =
      (
        formElement.querySelector(`label[for='${field.getAttribute("id")}']`) ||
        {}
      ).textContent
        ?.trim()
        ?.replaceAll("*", "") || "";

    return {
      name: field.getAttribute("name") || `field-${index}`,
      id: elementId,
      label: elementLabel || "",
      placeholder: field.getAttribute("placeholder") || "",
      required: field.hasAttribute("required"),
      identifier_placeholder: field.getAttribute("name") || "",
      type: field.getAttribute("type"),
      options:
        field.tagName.toLowerCase() === "select"
          ? Array.from(field.querySelectorAll("option")).map(
            (option) => option.value
          )
          : [],
    };
  });

  // Extract button information
  const buttonElement = formElement.querySelector("button[type='submit']");
  const button = {
    label: buttonElement?.textContent?.trim() || "",
  };

  // Build the final object
  return {
    type: "custom-form",
    name: formElement.getAttribute("name") || "",
    attributes,
    datafields,
    contact_list_id:
      parseInt(formElement.getAttribute("contact_list_id")) || null,
    domain: formElement.getAttribute("domain") || "",
    button,
  };
}

const handleComponents = (model) => {
  const datafields = model.get("datafields");
  const button = model.get("button");
  const domain = model.get("domain");
  const contact_list_id = model.get("contact_list_id");
  const name = model.get("name");

  let result = `
  <form
    method='post'
    id="main-form"
    class="custom-form"
    name="${name}"
    domain="${domain}"
    contact_list_id="${contact_list_id}"
  >
  `;

  datafields.forEach((item, i) => {
    if (item.type === "select") {
      result += handleDomSelect({ item, model, index: i });
    } else if (item.type === "checkbox") {
      result += handleDomCheckbox({ item, model, index: i });
    } else {
      result += handleDomInput({ item, model, index: i });
    }
  });

  result += `<button type="submit" class="submit-button">${button.label}</button> </form>`;

  return result;
};

const Grape = ({ defaultForm }) => {
  const lang = useLanguage((s) => s.language);
  const toSave = useFormStore((s) => s.toSave);
  const setToSave = useFormStore((s) => s.setToSave);

  const [init, setInit] = useState(false);
  const [editor, setEditor] = useState(false);

  const handleClick = () => {
    if (!editor) return;

    // Find the form component using its ID or class
    const formComponent = editor.getWrapper().find(".custom-form")[0]; // Replace #main-form with your form's selector

    if (formComponent) {
      // Get the DOM element associated with the form
      const formEl = formComponent.getEl();

      if (formEl) {
        // Simulate a click event on the DOM element
        formEl.click();
      }
    } else {
      console.warn("Form component not found!");
    }
  };

  const navigate = useNavigate();
  const handleSave = async () => {
    let requestMaker = defaultForm ? editForm : createForm;

    let html = editor.getHtml();
    let css = editor.getCss();

    let scripts = `<script type="text/javascript" src="https://cdn.tailwindcss.com/3.4.15"></script>
        <script src="https://cdn.jsdelivr.net/npm/sweetalert2@11"></script>
        <script>
         function showMessage() {
            Swal.fire({
              title: "Succès !",
              text: "Votre formulaire a bien été envoyé",
              icon: "success"
            });
          }

          // On form submit
          const mainForm = document.getElementById('main-form');
          mainForm.onsubmit = function(event) {          
            const xhr = new XMLHttpRequest();
            const formData = new FormData(this);

            xhr.open('POST', '/', true)

            xhr.onload = function () {
              if (xhr.status === 200) {
                // Display a success message
                showMessage()
              } else {
                // Handle error
                alert('Une erreur est survenue, veuillez réessayer.');
              }
            };

            // Handle network errors
            xhr.onerror = function () {
              alert('Request failed. Check your network connection.');
            };

            // Send the form data
            xhr.send(formData); 

            return false;
          };
        </script>`;

    if (useProfileStore.getState().profile.id === 3967) {
      scripts = `<script type="text/javascript" src="https://cdn.tailwindcss.com/3.4.15"></script>
        <script src="https://cdn.jsdelivr.net/npm/sweetalert2@11"></script>
        <script>
  function showMessage() {
    Swal.fire({
      title: "Merci !",
      icon: "success",
      html: \`
        Votre guide stratégique <b>"ETI : et si on poussait la rentabilité"</b> est prêt ! 
        Le téléchargement devrait débuter automatiquement d'ici quelques secondes.<br><br>
        Si ce n'est pas le cas, vous pouvez lancer le téléchargement ci-dessous.<br />
        <a href="https://app.files-magileads.net/file/695F633A6D131113619386/SAGE-EQUATIONS-RENTABILIT-MAJ20MAI.pdf" target="_blank" style="color: #3085d6; text-decoration: underline;">
          TELECHARGER LE GUIDE
        </a>.
      \`
    });
  }

  function triggerDownload() {
    const fileUrl = "https://app.files-magileads.net/file/695F633A6D131113619386/SAGE-EQUATIONS-RENTABILIT-MAJ20MAI.pdf";
    
    // Create an invisible link element
    const link = document.createElement('a');
    link.href = fileUrl;
    
    // 'download' attribute suggests a filename, though cross-origin policies 
    // might force the browser to open it in a new tab instead.
    link.setAttribute('download', 'SAGE-EQUATIONS-RENTABILIT.pdf'); 
    
    // // target="_blank" ensures that if it doesn't download automatically, 
    // // it opens in a new tab so the user doesn't lose the success message.
    link.target = '_blank'; 
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  // On form submit
  const mainForm = document.getElementById('main-form');
  mainForm.onsubmit = function(event) {          
    const xhr = new XMLHttpRequest();
    const formData = new FormData(this);

    xhr.open('POST', '/', true)

    xhr.onload = function () {
      if (xhr.status === 200) {
        // 1. Trigger the download
        triggerDownload();

        // 2. Display the success message
        showMessage();
      } else {
        // Handle error
        alert('Une erreur est survenue, veuillez réessayer.');
      }
    };

    // Handle network errors
    xhr.onerror = function () {
      alert('Request failed. Check your network connection.');
    };

    // Send the form data
    xhr.send(formData); 

    return false;
  };
</script>`;
    }

    let endbodyIndex = -7;
    let body = html.slice(0, endbodyIndex) + scripts + html.slice(endbodyIndex);

    const fullHtml = `
    <!DOCTYPE html>
    <html lang="fr">
      <head>
        <style>${css}</style>
      </head>
        ${body}
    </html>
`;

    return requestMaker({
      id: defaultForm?.id,
      contact_list_id: toSave?.contact_list_id,
      domain: toSave?.domain,
      html: fullHtml,
      name: toSave?.name,
    })
      .then((res) => {
        navigate(
          "/forms/list/?highlight=" + (defaultForm?.id || res.data.form_id)
        );
      })
      .finally(() => setToSave(null));
  };

  const handleQuit = () => {
    navigate("/forms/list");
  };

  useEffect(() => {
    if (toSave) {
      handleSave();
    }
  }, [toSave]);

  useLayoutEffect(() => {
    getFields();
    setToSave(null);
    const editor = grapesjs.init({
      canvas: {
        scripts: ["https://cdn.tailwindcss.com/3.4.15"],
      },
      container: "#gjs",
      height: "100%",
      width: "auto",
      fromElement: true,
      showOffsets: true,
      storageManager: { autosave: false, autoload: false },
      styleManager: {
        sectors: [
          {
            name: "General",
            open: false,
            properties: [
              {
                extend: "float",
                type: "radio",
                default: "none",
                options: [
                  { value: "none", className: "fa fa-times" },
                  { value: "left", className: "fa fa-align-left" },
                  { value: "right", className: "fa fa-align-right" },
                ],
              },
              "display",
              { extend: "position", type: "select" },
              "top",
              "right",
              "left",
              "bottom",
            ],
          },
          {
            name: "Dimension",
            open: false,
            properties: [
              "width",
              {
                id: "flex-width",
                type: "integer",
                name: "Width",
                units: ["px", "%"],
                property: "flex-basis",
                toRequire: 1,
              },
              "height",
              "max-width",
              "min-height",
              "margin",
              "padding",
            ],
          },
          {
            name: "Typography",
            open: true,
            properties: [
              "font-family",
              "font-size",
              "font-weight",
              "letter-spacing",
              "color",
              "line-height",
              {
                extend: "text-align",
                options: [
                  { id: "left", label: "Left", className: "fa fa-align-left" },
                  {
                    id: "center",
                    label: "Center",
                    className: "fa fa-align-center",
                  },
                  {
                    id: "right",
                    label: "Right",
                    className: "fa fa-align-right",
                  },
                  {
                    id: "justify",
                    label: "Justify",
                    className: "fa fa-align-justify",
                  },
                ],
              },
              {
                property: "text-decoration",
                type: "radio",
                default: "none",
                options: [
                  { id: "none", label: "None", className: "fa fa-times" },
                  {
                    id: "underline",
                    label: "underline",
                    className: "fa fa-underline",
                  },
                  {
                    id: "line-through",
                    label: "Line-through",
                    className: "fa fa-strikethrough",
                  },
                ],
              },
              "text-shadow",
            ],
          },
          {
            name: "Decorations",
            open: false,
            properties: [
              "opacity",
              "border-radius",
              "border",
              "box-shadow",
              "background", // { id: 'background-bg', property: 'background', type: 'bg' }
            ],
          },
          {
            name: "Extra",
            open: false,
            buildProps: ["transition", "perspective", "transform"],
          },
          {
            name: "Flex",
            open: false,
            properties: [
              {
                name: "Flex Container",
                property: "display",
                type: "select",
                defaults: "block",
                list: [
                  { value: "block", name: "Disable" },
                  { value: "flex", name: "Enable" },
                ],
              },
              {
                name: "Flex Parent",
                property: "label-parent-flex",
                type: "integer",
              },
              {
                name: "Direction",
                property: "flex-direction",
                type: "radio",
                defaults: "row",
                list: [
                  {
                    value: "row",
                    name: "Row",
                    className: "icons-flex icon-dir-row",
                    title: "Row",
                  },
                  {
                    value: "row-reverse",
                    name: "Row reverse",
                    className: "icons-flex icon-dir-row-rev",
                    title: "Row reverse",
                  },
                  {
                    value: "column",
                    name: "Column",
                    title: "Column",
                    className: "icons-flex icon-dir-col",
                  },
                  {
                    value: "column-reverse",
                    name: "Column reverse",
                    title: "Column reverse",
                    className: "icons-flex icon-dir-col-rev",
                  },
                ],
              },
              {
                name: "Justify",
                property: "justify-content",
                type: "radio",
                defaults: "flex-start",
                list: [
                  {
                    value: "flex-start",
                    className: "icons-flex icon-just-start",
                    title: "Start",
                  },
                  {
                    value: "flex-end",
                    title: "End",
                    className: "icons-flex icon-just-end",
                  },
                  {
                    value: "space-between",
                    title: "Space between",
                    className: "icons-flex icon-just-sp-bet",
                  },
                  {
                    value: "space-around",
                    title: "Space around",
                    className: "icons-flex icon-just-sp-ar",
                  },
                  {
                    value: "center",
                    title: "Center",
                    className: "icons-flex icon-just-sp-cent",
                  },
                ],
              },
              {
                name: "Align",
                property: "align-items",
                type: "radio",
                defaults: "center",
                list: [
                  {
                    value: "flex-start",
                    title: "Start",
                    className: "icons-flex icon-al-start",
                  },
                  {
                    value: "flex-end",
                    title: "End",
                    className: "icons-flex icon-al-end",
                  },
                  {
                    value: "stretch",
                    title: "Stretch",
                    className: "icons-flex icon-al-str",
                  },
                  {
                    value: "center",
                    title: "Center",
                    className: "icons-flex icon-al-center",
                  },
                ],
              },
              {
                name: "Flex Children",
                property: "label-parent-flex",
                type: "integer",
              },
              {
                name: "Order",
                property: "order",
                type: "integer",
                defaults: 0,
                min: 0,
              },
              {
                name: "Flex",
                property: "flex",
                type: "composite",
                properties: [
                  {
                    name: "Grow",
                    property: "flex-grow",
                    type: "integer",
                    defaults: 0,
                    min: 0,
                  },
                  {
                    name: "Shrink",
                    property: "flex-shrink",
                    type: "integer",
                    defaults: 0,
                    min: 0,
                  },
                  {
                    name: "Basis",
                    property: "flex-basis",
                    type: "integer",
                    units: ["px", "%", ""],
                    unit: "",
                    defaults: "auto",
                  },
                ],
              },
              {
                name: "Align",
                property: "align-self",
                type: "radio",
                defaults: "auto",
                list: [
                  {
                    value: "auto",
                    name: "Auto",
                  },
                  {
                    value: "flex-start",
                    title: "Start",
                    className: "icons-flex icon-al-start",
                  },
                  {
                    value: "flex-end",
                    title: "End",
                    className: "icons-flex icon-al-end",
                  },
                  {
                    value: "stretch",
                    title: "Stretch",
                    className: "icons-flex icon-al-str",
                  },
                  {
                    value: "center",
                    title: "Center",
                    className: "icons-flex icon-al-center",
                  },
                ],
              },
            ],
          },
        ],
      },
      plugins: [
        preset,
        basics,
        countdown,
        pluginExport,
        touch,
        parser,
        imageEditor,
        typed,
        styleBg,
      ],
      pluginsOpts: {
        [basics]: {
          flexGrid: true,
          blocks: [
            "column1",
            "column2",
            "column3",
            "text",
            "link",
            "image",
            "video",
          ],
        },
        [typed]: {
          block: {
            category: "Extra",
            content: {
              type: "typed",
              "type-speed": 40,
              strings: ["Text row one", "Text row two", "Text row three"],
            },
          },
        },
        [preset]: {
          blocks: ["text-basic"],
          modalImportTitle: "Import Template",
          modalImportLabel:
            '<div style="margin-bottom: 10px; font-size: 13px;">Paste here your HTML/CSS and click Import</div>',
          modalImportContent: function (editor) {
            return editor.getHtml() + "<style>" + editor.getCss() + "</style>";
          },
          useCustomTheme: true,
        },
      },
      i18n: {
        locale: "fr", // default locale
        detectLocale: false, // by default, the editor will detect the language
        localeFallback: "fr", // default fallback
        messages: { fr },
      },
      blockManager: {
        blocks: [
          {
            category: "Basic",
            label: lang.forms.form_item_name,
            media:
              '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M22 5.5c0-.3-.5-.5-1.3-.5H3.4c-.8 0-1.3.2-1.3.5v3c0 .3.5.5 1.3.5h17.4c.8 0 1.3-.2 1.3-.5v-3zM21 8H3V6h18v2zM22 10.5c0-.3-.5-.5-1.3-.5H3.4c-.8 0-1.3.2-1.3.5v3c0 .3.5.5 1.3.5h17.4c.8 0 1.3-.2 1.3-.5v-3zM21 13H3v-2h18v2z"/><rect width="10" height="3" x="2" y="15" rx=".5"/></svg>',
            content: { type: "custom-form" },
            activate: true,
            select: true,
          },
        ],
      },
    });

    // Main Form
    editor.DomComponents.addType("custom-form", {
      model: {
        defaults: {
          tagName: "form",
          name: "Mon Formulaire",
          handleSubmit: (e) => {
            alert("submitted !");
          },
          attributes: {
            method: "POST",
            action: "",
            class: "custom-form",
            id: "main-form",
          },
          datafields: [
            {
              name: "Email",
              id: 1,
              label: "Votre Email",
              placeholder: "test@email.com",
              required: true,
              identifier_placeholder: "%email%",
            },
          ],
          contact_list_id: null,
          domain: "",
          button: { label: "Valider" },
          components: handleComponents,
          styles: `
            .custom-form {
              display: flex;
              flex-direction: column;
              gap: 16px;
              width: 100%;
            }

            .form-row {
              display: flex;
              gap: 16px;
            }

            .form-element {
              display: flex;
              align-items: start;
              flex-direction: column;
              gap: 8px;
              font-family: sans-serif;
            }
            .form-element.checkbox {
              flex-direction: row;
              align-items: center;
            }
            .form-element .form-input {
              padding: 8px;
              border-radius: 4px;
              border: 1px solid #00000016;
              outline: 0;
              font-size: 16px;
              min-width: 250px;
              width: 100%;
            }

            .required-indicator {
              color: #c00;
            }
            .submit-button {
              margin-top: 16px;
              outline: 0;
              padding: 12px 16px;
              border: 0;
              border-radius: 6px;
              cursor: pointer;
              width: fit-content;
              font-size: 14px;
              text-transform: uppercase;
              font-weight: 500;
              color: #fff;
              background: #4b4bff;
              transition: all ease .3s;
              min-width: 150px;
              border: 1px solid;
              border-color: #fff;
            }
            .submit-button:hover {
              background: #fff;
              color: #4b4bff;
              border-color: #4b4bff;
            }
          `,
        },
        toHTML() {
          return handleComponents(this);
        },
      },
      view: {
        events: {
          click: "onActive",
        },
        onActive: script,
        init() {
          this.listenTo(this.model, "change:label", this.render);
          this.listenTo(this.model, "change:datafields", this.render);
          this.listenTo(this.model, "change:button", this.render);

          if (defaultForm) {
            const lang = useLanguage.getState().language;
            modals.open({
              modalId: "grape-modal",
              title: lang.forms.config_title,
              size: "xl",
              children: <GrapeModal current={this} editor={this.em} />,
            });
          }
        },
        onRender() {
          this.el.innerHTML = handleComponents(this.model);
        },
      },
    });

    //#region Beautify
    // Add and beautify tooltips
    let pn = editor.Panels;
    [
      ["sw-visibility", "Show Borders"],
      ["preview", "Preview"],
      ["fullscreen", "Fullscreen"],
      ["export-template", "Export"],
      ["undo", "Undo"],
      ["redo", "Redo"],
      ["gjs-open-import-webpage", "Import"],
      ["canvas-clear", "Clear canvas"],
    ].forEach(function (item) {
      pn.getButton("options", item[0]).set("attributes", {
        title: item[1],
        "data-tooltip-pos": "bottom",
      });
    });
    [
      ["open-sm", "Style Manager"],
      ["open-layers", "Layers"],
      ["open-blocks", "Blocks"],
    ].forEach(function (item) {
      pn.getButton("views", item[0]).set("attributes", {
        title: item[1],
        "data-tooltip-pos": "bottom",
      });
    });
    // Do stuff on load
    editor.on("load", function () {
      var $ = grapesjs.$;

      // Show borders by default
      pn.getButton("options", "sw-visibility").set({
        command: "core:component-outline",
        active: true,
      });

      // Load and show settings and style manager
      var openTmBtn = pn.getButton("views", "open-tm");
      openTmBtn && openTmBtn.set("active", 1);
      var openSm = pn.getButton("views", "open-sm");
      openSm && openSm.set("active", 1);

      // Remove trait view
      pn.removeButton("views", "open-tm");

      // Add Settings Sector
      var traitsSector = $(
        '<div class="gjs-sm-sector no-select">' +
        '<div class="gjs-sm-sector-title"><span class="icon-settings fa fa-cog" style="margin-left: 4px;"></span> <span class="gjs-sm-sector-label" style="margin-left: 8px;">Attributs</span></div>' +
        '<div class="gjs-sm-properties" style="display: none;"></div></div>'
      );
      var traitsProps = traitsSector.find(".gjs-sm-properties");
      traitsProps.append($(".gjs-traits-cs"));
      $(".gjs-sm-sectors").before(traitsSector);
      traitsSector.find(".gjs-sm-sector-title").on("click", function () {
        var traitStyle = traitsProps.get(0).style;
        var hidden = traitStyle.display == "none";
        if (hidden) {
          traitStyle.display = "block";
        } else {
          traitStyle.display = "none";
        }
      });
      // Open block manager
      setTimeout(() => {
        document.querySelector(".gjs-pn-views .gjs-pn-btn:last-child").click();
      }, 100);

      // Add a default custom form
      const targetContainer = editor.getWrapper().find("#main-form")[0];

      targetContainer.replaceWith(parseCustomForm(editor.getHtml()));
      setInit(true);
    });

    editor.getWrapper().addStyle({
      fontFamily: "sans-serif",
    });

    setEditor(editor);
    //#endregion
  }, []);

  return (
    <Stack
      height={"100vh"}
      sx={{
        "& .gjs-one-bg": {
          background: "var(--mantine-color-gray-8)",
        },
        ".gjs-pn-devices-c": {
          ml: 12,
        },
        "& .gjs-four-color-h": {
          color: "var(--mantine-color-secondary-0)",
        },
        "& .gjs-four-color-h:hover": {
          color: "var(--mantine-color-secondary-6)",
        },
      }}
    >
      <Tooltip label={lang.forms.quit} position={"bottom"}>
        <Button
          pos={"absolute"}
          top={3}
          left={86}
          style={{ zIndex: 100, boxShadow: "#00000033 0 2px 6px" }}
          size="lg"
          h={34}
          px={12}
          onClick={handleQuit}
        >
          <IconArrowLeft />
        </Button>
      </Tooltip>
      <div
        id="gjs"
        style={{ fontFamily: "Arial, sans-serif" }}
        dangerouslySetInnerHTML={{ __html: defaultForm?.html || htmlFile }}
      ></div>

      <LoadingOverlay visible={!!toSave} zIndex={101} />

      <Button
        pos={"absolute"}
        bottom={16}
        right={320}
        style={{ zIndex: 100, boxShadow: "#00000033 0 2px 6px" }}
        size="md"
        onClick={handleClick}
        leftSection={<IconDeviceFloppy size={22} />}
      >
        {lang.forms.save}
      </Button>
    </Stack>
  );
};

export default Grape;
